import { render } from "./PaginaNoEncontrada.vue?vue&type=template&id=f023fb5e&scoped=true"
import script from "./PaginaNoEncontrada.vue?vue&type=script&lang=js"
export * from "./PaginaNoEncontrada.vue?vue&type=script&lang=js"

import "./PaginaNoEncontrada.vue?vue&type=style&index=0&id=f023fb5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f023fb5e"]])

export default __exports__